import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e214460"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "share" }
const _hoisted_2 = {
  key: 0,
  class: "share-loading"
}
const _hoisted_3 = {
  key: 1,
  class: "share-footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_redpack_info = _resolveComponent("redpack-info")!
  const _component_loading = _resolveComponent("loading")!
  const _component_personality_button = _resolveComponent("personality-button")!
  const _component_layout = _resolveComponent("layout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_layout, { class: "share-red" }, {
      header: _withCtx(() => [
        _createVNode(_component_redpack_info, {
          chainId: _ctx.query.chainIdInit,
          redPackId: _ctx.query.redPackId
        }, null, 8, ["chainId", "redPackId"])
      ]),
      footer: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_loading)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_personality_button, {
                type: "dark",
                class: "share-footer-share",
                onClick: _ctx.shareHandler
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h3", null, _toDisplayString(_ctx.$checkI18n("share")), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_personality_button, {
                type: "white",
                onClick: _ctx.copyHandler
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h3", null, _toDisplayString(_ctx.$checkI18n("copyLink")), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
      ]),
      _: 1
    })
  ]))
}